<template>
  <div id="app">
    <header v-if="is_login == false">
      <Tooltip
        class="setting_btn"
        placement="bottom-end"
        :content="$t('logout')"
      >
        <Icon @click="logout" type="ios-log-out" id="exit1" />
      </Tooltip>
      <!-- <Tooltip class="setting_btn" placement="bottom-end" :content="$t('role_switch')">
        <Icon @click="roleSwitch" type="ios-git-network" id="user_side"/>
      </Tooltip> -->
      <!-- emoment小助手 -->
      <Tooltip
        class="setting_btn"
        placement="bottom-end"
        :content="$t('help_center')"
      >
        <img
          @click="showLittleHelp"
          src="../static/images/header_help.svg"
          style="display:block;margin-top: 3px;"
          alt=""
        />
      </Tooltip>
      <Dropdown
        style="margin-left: 20px;float: right"
        v-on:on-click="switchLang"
        trigger="click"
        id="swtich_lang_dropdown1"
      >
        <Button type="primary">
          {{ current_lang }}
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem
            v-for="(item, index) in lang_list"
            :name="index"
            :key="index"
            :id="'swtich_lang_dropdown1_' + index"
            >{{ item }}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <h1 class="iconfont icon-emoment"></h1>
    </header>
    <div class="body" :style="{ height: pageHeight + 'px' }">
      <div style="height: 95vh;overflow-y: scroll;padding-bottom: 100px">
        <Layout :style="{ height: '100vh' }" v-if="is_login == false">
          <Sider collapsible :collapsed-width="70" v-model="isCollapsed">
            <Menu
              theme="light"
              :open-names="openMenuArr"
              width="auto"
              :class="menuitemClasses"
            >
              <Submenu name="basic" v-if="checkRole('basic')">
                <template slot="title" id="basic_data">
                  <Icon type="ios-paper" />
                  <span>{{ "network_space" | t }}</span>
                </template>
                <MenuItem
                  name="zoom_room_list"
                  to="/MeetingRoomList"
                  id="conference_room"
                >
                  <Icon type="ios-apps" />
                  <span :title="$t('zoom_meeting_room')">{{
                    "zoom_meeting_room" | t
                  }}</span>
                </MenuItem>
                <MenuItem
                  name="live_room_list"
                  to="/LiveMeetingRoomList"
                  id="live_room"
                >
                  <Icon type="ios-apps" />
                  <span :title="$t('live_meeting_room')">{{
                    "live_meeting_room" | t
                  }}</span>
                </MenuItem>
                <MenuItem name="tag_list" to="/TagList" id="dictionaries">
                  <Icon type="ios-pricetag" />
                  <span>{{ "tag" | t }}</span>
                </MenuItem>
                <!-- <MenuItem name="company" to="/CompanyList" id="Customer_group">
                  <Icon type="ios-contacts" />
                  <span>{{ 'account_group' | t }}</span>
                </MenuItem> -->
                <MenuItem name="user" to="/UserList" id="user">
                  <Icon type="ios-people" />
                  <span>{{ "partner_pool" | t }}</span>
                </MenuItem>
                <MenuItem name="helpCenter" to="/HelpCenter" id="helpCenter">
                  <Icon type="ios-book" />
                  <span :title="$t('help_center')">{{
                    "help_center" | t
                  }}</span>
                </MenuItem>
                <MenuItem name="notice" to="/Notice" id="notice">
                  <div style="display:flex;align-items: center;">
                    <img src="../static/images/公告管理.svg" alt="" />
                    <span style="margin-left:5px;">{{ "notice" | t }}</span>
                  </div>
                </MenuItem>
                <MenuItem name="application" to="/Application" id="application">
                  <Icon type="ios-apps-outline" />
                  <span>{{ "application" | t }}</span>
                </MenuItem>

                <!-- 以下为settings的二级菜单 -->
                <MenuGroup title="SETTINGS">
                  <MenuItem name="admin" to="/AdminList" id="Administrator">
                    <Icon type="ios-person" />
                    <span>{{ "admin" | t }}</span>
                  </MenuItem>
                  <MenuItem
                    name="report_list"
                    to="/ReportViewerList"
                    id="ReportViewer"
                  >
                    <Icon type="ios-person" />
                    <span>{{ "report_viewer.title" | t }}</span>
                  </MenuItem>
                  <MenuItem
                    name="sensitive"
                    to="/SensitiveWords"
                    id="sensitive_word"
                  >
                    <Icon type="ios-quote" />
                    <span>{{ "chat_block_word" | t }}</span>
                  </MenuItem>
                  <MenuItem
                    name="videoManage"
                    to="/VideoManage"
                    id="video_manage"
                  >
                    <Icon type="ios-videocam" />
                    <span>{{ "video_manage" | t }}</span>
                  </MenuItem>
                  <MenuItem
                    name="channelManage"
                    to="/ChannelManage"
                    id="channel_manage"
                  >
                    <Icon type="md-pulse" />
                    <span> {{ $t("channel_manage") }} </span>
                  </MenuItem>
                  <!-- <MenuItem name="channelManage" to="/ChannelManage" id="channel_manage">
                    <Icon type="md-pulse" />
                    <span> {{ $t('channel_manage')  }} </span>
                  </MenuItem> -->
                </MenuGroup>
              </Submenu>
              <Submenu name="event" v-if="checkRole('event')">
                <template slot="title" id="management_of_activities">
                  <Icon type="ios-list-box" />
                  <span>{{ "event_management" | t }}</span>
                </template>
                <MenuItem name="event_list" to="/EventList" id="activity">
                  <Icon type="md-list" />
                  <span>{{ "event" | t }}</span>
                </MenuItem>

                <!-- <MenuItem name="2-2">ATTENDEE</MenuItem> -->
              </Submenu>
              <Submenu name="sport_setting" v-if="checkRole('basic')">
                <template slot="title" id="sport_setting">
                  <Icon type="md-football" />
                  <span>{{ $t("sport_setting")  }}</span>
                </template>
                <MenuItem name="sport" to="/Sport" id="sport">
                  <div style="display:flex;align-items: center;">
                    <img
                      src="../static/images/sport.svg"
                      style="margin-right: 3px;"
                      width="16"
                      height="16"
                    />
                    <div>{{ $t("sport.name") }}</div>
                  </div>
                </MenuItem>
              </Submenu>
              <Submenu name="report" v-if="report_list.length > 0">
                <template slot="title" id="bi_report">
                  <Icon type="md-grid" />
                  <span>{{ "bi_report" | t }}</span>
                </template>
                <MenuItem
                  :name="item.report_name"
                  :to="'/Report?url=' + encodeUrl(item.report_url)"
                  v-for="(item, index) in report_list"
                  :key="index"
                >
                  <Icon type="md-grid" />
                  <span>{{ item.report_name }}</span>
                </MenuItem>
              </Submenu>
            </Menu>
          </Sider>
        </Layout>
      </div>

      <!-- <div class="menu" >
      </div> -->
      <div
        :class="is_login ? 'loginbg' : 'action'"
        :style="isCollapsed ? 'padding-left: 80px' : 'padding-left: 210px;'"
        style="height: 100%"
      >
        <router-view />
      </div>
      <!-- <canvas v-show="false" id="forSnapShot"></canvas> -->
    </div>
    <litter_helper
      v-if="user_info_detail.user_code"
      ref="litter_helper"
    ></litter_helper>
  </div>
</template>

<script>
import { me, update_me, begin_user_admin_site_promotion } from "@/api/user";
import { get_event_stage_code_master_data } from "@/api/event";
import { get_report_list_by_role } from "@/api/report";
import litter_helper from "@/components/litter_helper";
import role from "@/libs/role";
import _ from "lodash";

export default {
  name: "App",
  components: {
    litter_helper
  },
  data() {
    return {
      pageHeight: window.innerHeight - 61,
      isCollapsed: false,
      openMenuArr: ["basic", "event"],
      is_login: false,
      role_list: [],
      user_menu: [],
      lang_list: {
        en: "ENGLISH",
        cn: "简体中文",
        tw: "繁體中文"
      },
      current_lang: "简体中文",
      user_info_detail: {},
      report_list: []
    };
  },
  computed: {
    menuitemClasses: function() {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    }
  },
  beforeCreate() {
    this.$store.commit("reset_ajax_spin");
  },
  created() {
    let self = this;
    self.$Spin.show();

    let getRouteNameInterval = setInterval(() => {
      if (self.$route.path != "/" || self.$route.name != null) {
        clearInterval(getRouteNameInterval);

        self.checkIsLogin();
        if ($cookies.get("kls_user_session") != null) {
          me().then(res => {
            self.user_info_detail = res.body;
            this.$store.commit("setUserInfo", res.body);
            // sessionStorage.setItem("userName", res.body.name)
            let lang =
              self.user_info_detail.language == null ||
              self.user_info_detail.language == undefined ||
              self.user_info_detail.language == ""
                ? "cn"
                : self.user_info_detail.language;
            self.$i18n.locale = lang;
            self.current_lang = self.lang_list[lang];
            // sessionStorage.setItem("language", self.lang_list[lang])
            this.$store.commit("setCurrentLanguage", this.current_lang);
            $cookies.set("kls_user_language", lang);
            if (
              self.user_info_detail.language == null ||
              self.user_info_detail.language == undefined ||
              self.user_info_detail.language == ""
            ) {
              self.user_info_detail.language = lang;
              self.updateMe();
            }

            get_event_stage_code_master_data().then(res => {
              this.$store.commit("set_stage_status_list", res.body);
            });

            get_report_list_by_role().then(res => {
              self.report_list = res.body;
              let report_url_template = process.env.REPORT_URL;
              let token = $cookies.get("kls_user_session");
              if (self.report_list.length > 0) {
                self.openMenuArr.indexOf("report")
                  ? ""
                  : self.openMenuArr.push("report");

                _.forEach(self.report_list, v => {
                  let url = report_url_template;
                  url = url.replace("#token#", token);
                  url = url.replace("#user_role#", v.user_role);
                  url = url.replace(
                    "#url#",
                    encodeURIComponent(encodeURIComponent(v.report_url))
                  );

                  v.report_url = url;
                  // console.info("report_url_template", v)
                });
              }
            });
          });
        }
      }
    }, 10);

    setTimeout(() => {
      self.checkIsLogin();
    }, 200);
  },
  mounted() {
    let self = this;

    window.onresize = () => {
      if (self.is_login == true) {
        self.pageHeight = window.innerHeight - 1;
      } else {
        self.pageHeight = window.innerHeight - 61;
      }
      // console.info("height", self.pageHeight)
    };
  },
  methods: {
    showLittleHelp() {
      this.$refs.litter_helper.showLittleHelp();
    },
    checkIsLogin() {
      let self = this;
      if ($cookies.get("kls_user")) {
        self.role_list = $cookies.get("kls_user")["role_list"];
        self.initUserMenu();
      } else {
        if (!(self.$route.name == "Login" || self.$route.path == "/")) {
          location.href = process.env.USER_PORTAL_URL;
          return;
        }
      }

      if (self.$route.name == "Login" || self.$route.path == "/") {
        self.is_login = true;
      } else {
        self.is_login = false;
      }
      if (self.is_login == true) {
        self.pageHeight = window.innerHeight - 1;
        self.$Spin.hide();
      } else {
        self.pageHeight = window.innerHeight - 61;
      }
    },
    logout() {
      let self = this;
      $cookies.keys().forEach(cookie => this.$cookies.remove(cookie));
      self.$Spin.show();
      setTimeout(() => {
        location.href = process.env.USER_PORTAL_URL;
      }, 500);
    },
    roleSwitch() {
      begin_user_admin_site_promotion().then(res => {
        location.href =
          process.env.USER_PORTAL_URL +
          "?from=jump&promotion_code=" +
          res.body.code;
      });
    },
    goTo(path) {
      location.href = path;
    },
    initUserMenu() {
      let self = this;
      let tmp = [];
      self.role_list.forEach(o => {
        if (role[o] != undefined) {
          tmp = [...tmp, ...role[o]];
        }
      });
      self.user_menu = _.uniq(tmp);
    },
    checkRole(menu) {
      return this.user_menu.indexOf(menu) >= 0;
    },
    switchLang(name) {
      $cookies.set("kls_user_language", name);
      this.$i18n.locale = name;
      this.user_info_detail.language = name;
      this.current_lang = this.lang_list[name];
      this.$store.commit("setCurrentLanguage", this.current_lang);
      this.updateMe(() => {
        location.reload();
      });
    },
    updateMe(cb) {
      update_me(this.user_info_detail).then(res => {
        if (cb) {
          cb();
        }
      });
    },
    encodeUrl(str) {
      return btoa(str);
    }
  }
};
</script>

<style lang="less">
* {
  font-family: Tahoma;
  // font-size: 12px;
  font-family: OneNikeCurrency, "FuturaW01-ExtraBoldCond 774896",
    Futura-CondensedMedium, Roboto-Condensed-Light;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;

  .loginbg {
    position: relative;
    background: #000;
    padding-left: 0 !important;

    &:after {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 2;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: url("/static/images/login.jpg") no-repeat center center;
      opacity: 0.5;
    }
  }

  header {
    height: 60px;
    padding: 10px;
    width: 100%;
    background: #000;
    overflow: hidden;

    h1 {
      height: 40px;
      // padding-left: 50px;
      width: 300px;
      // background: url("/static/logo.svg") no-repeat 0 center;
      // background-size: 40px 40px;
      color: #fff;
      font-size: 40px;
      font-weight: normal;
      line-height: 40px;
      text-align: left;
    }

    button {
      float: right;
      color: #fff;
      border: 1px solid #fff;
      border-radius: 3px;
      line-height: 30px;
      font-size: 16px;
      line-height: 16px;
      background: none;
      padding: 7px 20px;
    }

    .setting_btn {
      float: right;
      color: #fff;
      font-size: 35px;
      height: 40px;
      line-height: 40px;
      margin-left: 20px;
      cursor: pointer;

      &:hover {
        color: #ddd;
      }
    }
  }

  .body {
    overflow: hidden;
    position: relative;

    .ivu-layout-sider {
      background: #fff;
    }

    .ivu-layout-sider-trigger {
      background: #e6e6e6;
      color: #000;
    }

    .menu-item {
      span {
        display: inline-block;
        overflow: hidden;
        width: 100px;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
        transition: width 0.2s ease 0.2s;
      }
      #helpCenter span {
        // width: 105px !important;
      }

      .ivu-menu-item-group-title {
        font-size: 14px;
        height: 48px;
        transition: height 0.2s ease;
      }

      i {
        margin-right: 0px;
        transition: margin-right 0.2s ease 0.2s, transform 0.2s ease 0.2s;
      }
    }

    .collapsed-menu {
      span {
        width: 0px;
        transition: width 0.2s ease;
      }

      .ivu-menu-item-group-title {
        font-size: 0px;
        height: 0px;
        transition: height 0.2s ease;
      }

      i {
        margin-right: -12px;
        transition: margin-right 0.2s ease 0.2s, transform 0.2s ease 0.2s;
      }

      .ivu-menu-item {
        padding: 14px 14px;
        position: relative;
        cursor: pointer;
        z-index: 1;
        transition: all 0.2s ease-in-out;
      }
    }

    .action {
      position: absolute;
      width: 100%;
      background: #fff;
      top: 0;
      left: 0;
      padding-right: 10px;
      padding-top: 10px;
      // z-index: 1;
      overflow-y: auto;
      height: calc(100vh - 50px);

      .container {
        width: 100%;

        h2 {
          margin-bottom: 10px;
          overflow: hidden;

          button {
            float: right;
          }
        }
      }
    }
  }
}

.drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  z-index: 10;
}

.prism-player .prism-cc-btn {
  background-image: url("/static/images/cc.png");
  width: 28px;
  height: 28px;
  margin-top: 9px !important;

  &:hover {
    animation: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue